import { token } from "./token.js";
import { makeInternalTokens } from "./makeInternalTokens.js";
const {
  internalTokens,
  declareTokens
} = makeInternalTokens({
  lightTheme: {
    "tooltip-background": token.gray10,
    "tooltip-shadow": `${token.elevation2}, ${token.elevationStatic}`,
    "tooltip-title-color": token.colorText,
    "tooltip-secondary-text-color": token.colorTextMuted,
    "tooltip-text-color": token.colorTextMuted
  },
  darkTheme: {
    "tooltip-background": token.gray100,
    "tooltip-shadow": "0 2px 4px -1px rgb(3 16 38 / 10%), 0 0 0 1px rgb(3 16 38 / 10%)",
    // temporarily hardcode values, because there are no shadows defined for a dark theme
    "tooltip-title-color": token.gray1000,
    "tooltip-secondary-text-color": token.gray600,
    "tooltip-text-color": token.gray800
  }
});
export {
  declareTokens,
  internalTokens
};
//# sourceMappingURL=themes3.js.map
